<template>
    <el-tabs v-model="activeActiveCom" type="card" @tab-click="handleTabs">
        <el-tab-pane v-for="item in tabsArray" :key="item.name" :name="item.name" :label="$t(item.label)"></el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    data() {
        return {
            activeActiveCom: 'Sensor',
            tabsArray: [
                {
                    name: 'Sensor',
                    label: $t('deviceType.sensor')
                },
                {
                    name: 'Gateway',
                    label: $t('public.gateway')
                },
                {
                    name: 'Display',
                    label: $t('deviceType.display')
                },
                {
                    name: 'Relay',
                    label: $t('public.relay')
                },
                {
                    name: 'Plinth',
                    label: $t('integration.thermometer_base')
                },
                // 增加气体和门磁
                {
                    name: 'Gas',
                    label: $t('route.gas')
                },
                {
                    name: 'Magnetism',
                    label: $t('route.magnetism')
                }
            ]
        };
    },
    methods: {
        handleTabs({ name, label }) {
            this.$emit('tabClick', { name, label });
        }
    }
};
</script>

<style></style>
